import { ConceptLinkerAiLinkerItemStatus } from 'types/conceptLinkerAiLinker';

export function aiLinkerItemStatusRenderer(params: { value?: any; data?: any }) {
  if (params.value === undefined || params.value === null) {
    return '';
  }

  const status = parseInt(params.value);

  switch (status) {
    case ConceptLinkerAiLinkerItemStatus.PENDING:
      return '<span class="fa fa-circle-pause" style="color: #ff9800;" title="Pending"></span>';

    case ConceptLinkerAiLinkerItemStatus.NEEDS_REVIEW:
      return '<span class="fa fa-user" style="color: #2196f3;" title="Needs User Review"></span>';

    case ConceptLinkerAiLinkerItemStatus.DONE:
      return '<span class="fa fa-check-circle" style="color: #4caf50;" title="Reviewed"></span>';

    case ConceptLinkerAiLinkerItemStatus.ERROR:
      return '<span class="fa fa-exclamation-triangle" style="color: #f44336;" title="Error"></span>';

    default:
      return '';
  }
}
